module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w1180 mt10"
  }, [_c('h4', {
    staticClass: "modtit1 clearfix"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _c('a', {
    staticClass: "more fr",
    attrs: {
      "href": _vm.moreurl
    }
  }, [_vm._v("更多 >")])])]), _vm._v(" "), _c('div', {
    staticClass: "w1180 clearfix",
    attrs: {
      "id": _vm.lesstype == 'ggk' ? 'gkclass' : 'jsclass'
    }
  }, [_c('div', {
    staticClass: "modconl fl"
  }), _vm._v(" "), _c('div', {
    style: (_vm.lesstype == 'ggk' ? '' : 'display:none'),
    attrs: {
      "id": "lessonclude"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b345f96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson.vue
// module id = 20
// module chunks = 0